import MainLayout from "../../layout/MainLayout";
import FilterSection from "../../components/FilterSection";
import { Button } from "antd";
import DataTable from "../../common/Tables/DataTable";
import { PlusOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { actionPost, assignPost, getApi, useApiCall } from "../../services/api";
import { useDispatch, useSelector } from "react-redux";
import useExpiredToken from "../../utils/useExpiredToken";
import { getAssignTableColumns, ShowData } from "../../utils/ShowData";
import Assign from "../../components/models/Assign";
import { useToast } from "../../utils/Toast";
import Success from "../../components/models/Success";
import { setQA } from "../../redux/slices/qAType";
import { useNavigate } from "react-router-dom";
import { processEncryptedResponse } from "../../utils/ResponseDecreypt";
import AssignedCallDetails from "../../components/models/AssignedCallDetails";
import { filterDataFunc, qaTypeButtons } from "../../constant";
import AppSelect from "../../common/FormInputs/AppSelect";
import SelectAuditType from "../../components/models/SelectAuditType";
import DeleteModal from "../../components/models/DeleteModal";

const AssignCalls = () => {
  const { callApi } = useApiCall();
  const [data, setData] = useState([]);
  const [qaList, setQAList] = useState([]);
  const [open, setOpen] = useState(false);
  const [isAuditTypeModalOpen, setIsAuditTypeModalOpen] = useState(false);
  const [selectQA, setSelectQA] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [fetchRefresh, setFetchRefresh] = useState(false);

  const token = useSelector((state) => state.auth.jwtToken);
  const expireToken = useExpiredToken();
  const { searchText } = useSelector((state) => state.search);
  const { type } = useSelector((state) => state.qaType);
  const dispatch = useDispatch();
  const toast = useToast();
  const [deleteData, setDeleteData] = useState({});
  const navigate = useNavigate();
  const handleDeleteCall = (record) => {
    setDeleteData(record);
    setIsDeleteModalOpen(true);
  };
  const updatedColumns = getAssignTableColumns((record) => {
    setSelectedRow(record);
    setIsDetailsModalOpen(true);
  }, handleDeleteCall);

  const handleCancel = () => {
    setOpen(false);
    setIsModalOpen(false);
    setIsDeleteModalOpen(false);
    setIsDetailsModalOpen(false);
  };

  const handleDelete = async () => {
    const res = await actionPost(
      `calls/summary`,
      token,
      "DELETE",
      { id: deleteData?.id },
      expireToken
    );
    const { status } = await callApi({
      endpoint: `calls/summary`,
      apiMethod: "post",
      bodyData: { action: "DELETE", input: { id: deleteData?.id } },
    });
    if (status) {
      setIsDeleteModalOpen(false);
      // fetchData();
      setFetchRefresh((prev) => !prev);
      toast.success(data?.message);
    } else {
      toast.error(data?.message);
    }
  };

  const showLoading = async () => {
    const isDone = await assignQA();
    if (isDone) {
      setTimeout(() => {
        setOpen(false);
      }, 200);
      setTimeout(() => {
        setIsModalOpen(true);
      }, 500);
    }
  };

  // const fetchData = async () => {
  //   if (type) {
  //     const { decrypted, status } = await callApi({
  //       endpoint: `calls/audit-filter`,
  //       queryParams: { auditTypeId: type, filterType: "NOT_ASSIGNED" },
  //       showToast: false,
  //     });

  //     if (status) {
  //       setData(decrypted);
  //     }
  //   } else {
  //     const res = await actionPost("calls/summary", token, "READ_ALL", {}, expireToken);
  //     const data = await processEncryptedResponse(res);
  //     if (data) {
  //       setData(data);
  //     }
  //   }
  //   setSelectedRows([]);
  // };

  const mappedData = data?.map((item) => ShowData(item));
  const filteredData = filterDataFunc(mappedData, searchText);

  const fetchAllQA = async () => {
    const res = await getApi("superadmin/users/qa/dynamic", token, expireToken);

    const data = await processEncryptedResponse(res);
    if (data) {
      const mappedQAList =
        data?.users?.map((qa) => ({
          label: `${qa.full_name} (${qa.email})`,
          value: qa.username,
        })) || [];
      setQAList(mappedQAList);
    }
  };

  const assignQA = async () => {
    if (!type) {
      toast.error("Please select QA Type");
      return;
    }
    if (!selectQA) {
      toast.error("Please select a QA");
      return;
    }
    let qaData = {
      callIds: selectedRows.map((item) => item.id),
      auditTypes: [type],
      qaUser: selectQA,
    };
    const res = await assignPost("calls/assign-to-qa", token, qaData, expireToken, toast);
    if (res.status === 200 || res.status === 201) {
      // fetchData();
      setFetchRefresh((prev) => !prev);
      setSelectedRows([]);
      return true;
    } else {
      return false;
    }
  };

  const OnSelect = (value) => {
    dispatch(setQA(value));
  };

  const onChange = (value) => {
    setSelectQA(value);
  };

  useEffect(() => {
    fetchAllQA();
    if (!type) {
      setIsAuditTypeModalOpen(true);
    }
  }, []);

  // useEffect(() => {
  //   fetchData();
  // }, [type]);

  const handleBack = (type = null) => {
    setOpen(false);
    setIsModalOpen(false);
    if (type == "back") {
      navigate("/assign-calls");
    } else {
      navigate("/assigned-calls");
    }
  };

  const handleOnChange = (value) => {
    dispatch(setQA(value || null));
  };

  return (
    <>
      <>
        <div className="container-fluid">
          {/* <div className="">
            <FilterSection />
          </div> */}
          <div className="pb-3 col-12 col-sm-3">
            <AppSelect
              label=""
              name="batch_number"
              type="text"
              placeholder="Audit Type"
              options={qaTypeButtons.map((item) => ({
                value: item.id,
                label: item.label,
              }))}
              value={type || null}
              rules={[{ required: true, message: "Please select the item!" }]}
              onChange={handleOnChange}
              allowClear
              open={!!dropdownVisible}
              onDropdownVisibleChange={(visible) => setDropdownVisible(visible)}
              error={typeof dropdownVisible === "string" ? dropdownVisible : ""}
            />
          </div>
          <DataTable
            updatedColumns={updatedColumns}
            callApiArgs={
              type
                ? {
                    endpoint: "calls/audit-filter",
                    queryParams: {
                      auditTypeId: type || undefined,
                      filterType: "NOT_ASSIGNED",
                      accessorKey: "users",
                    },
                    dependencies: [type, fetchRefresh],
                  }
                : {
                    endpoint: "calls/summary",
                    bodyData: {
                      action: "READ_ALL",
                      input: {},
                    },
                    apiMethod: "post",
                    dependencies: [type, fetchRefresh],
                  }
            }
            isCheck={true}
            setSelectedRows={setSelectedRows}
            auditTypeModal={() => {
              setDropdownVisible("Please select an audit type first.");
            }}
          />
        </div>
        <div className="fixed-button-wrapper">
          <Button
            type="primary"
            className="assign-btn"
            icon={<PlusOutlined />}
            onClick={() => {
              if (!type) {
                setDropdownVisible("Please select an audit type first.");
              } else if (selectedRows.length === 0) {
                toast.error("Please select at least one call.");
              } else {
                setOpen(true);
              }
            }}
            title={
              !type
                ? "Please select Audit Type"
                : selectedRows.length === 0
                ? "Please select at least one call"
                : ""
            }
          >
            Assign
          </Button>
        </div>
        <Assign
          handleCancel={handleCancel}
          showLoading={showLoading}
          open={open}
          OnSelect={OnSelect}
          QATYPE={type}
          qaList={qaList}
          onChange={onChange}
        />
        <SelectAuditType
          open={isAuditTypeModalOpen}
          handleCancel={() => setIsAuditTypeModalOpen(false)}
          handleSubmit={(tempType) => {
            OnSelect(tempType);
            setIsAuditTypeModalOpen(false);
          }}
          QATYPE={type}
        />
        <Success handleCancel={handleCancel} open={isModalOpen} handleBack={handleBack} />
        <DeleteModal
          handleCancel={handleCancel}
          open={isDeleteModalOpen}
          handleDelete={handleDelete}
          title={"Delete call?"}
          description={"Are you sure you want to delete this call?"}
        />
        <AssignedCallDetails
          open={isDetailsModalOpen}
          handleCancel={handleCancel}
          formData={selectedRow}
        />
      </>
    </>
  );
};

export default AssignCalls;
